import React, { useState, useEffect, useRef, useCallback } from "react";
import { Provider } from "react-redux";
import store from "../redux/store/store";
import useCurrentState from "../hooks/useCurrentState";
import { useDrag } from "react-use-gesture";
import logo from "../assets/logo.png";
import { useDimensions } from "../hooks/useDimensions";
export const ThemeContext = React.createContext();

const Qcast = (props) => {
  const { open, state, setOpen, isTrimming, getStarted } = useCurrentState();
  const [componentPos, setComponentPos] = useState({ a: 0, b: 0 });
  const { height, width } = useDimensions();
  const [initial, setInitial] = useState(true);

  // const [container, setContainer] = useState({current: {clientWidth: 504, clientHeight: 364}})

  const container = useRef(null);

  useEffect(() => {
    document.addEventListener("DOMSubtreeModified", (e) => {
      if (open) {
        const containerElem = document.getElementById("containerMain1234");
        container.current = {
          clientWidth: containerElem.clientWidth,
          clientHeight: containerElem.clientHeight,
        };

        window.parent.postMessage(
          [
            "x",
            "qcast-active",
            `${container.current.clientWidth + 40}px`,
            `${container.current.clientHeight + 100}px`,
          ],
          "*"
        );
      }
    });

    if (open) {
      window.parent.postMessage(
        [
          "x",
          "qcast-active",
          `${container.current.clientWidth + 40}px`,
          `${container.current.clientHeight + 100}px`,
        ],
        "*"
      );
    }

    return () => {
      document.removeEventListener("DOMSubtreeModified", (e) => {
        if (open) {
          const containerElem = document.getElementById("containerMain1234");
          container.current = {
            clientWidth: containerElem.clientWidth,
            clientHeight: containerElem.clientHeight,
          };
          window.parent.postMessage(
            [
              "x",
              "qcast-active",
              `${containerElem.clientWidth + 40}px`,
              `${containerElem.clientHeight + 100}px`,
            ],
            "*"
          );
        }
      });
    };
  }, [open, state]);

  const bindComponentPos = useDrag(
    (state) => {
      if (isTrimming) {
        state.cancel();
        return;
      }
      setComponentPos({
        a: state.offset[0],
        b: state.offset[1],
      });
    },
    {
      bounds: {
        right: 0,
        left: -width + 485,
        top: -97,
        bottom: height - 368,
      },
    }
  );

  return (
    <Provider store={store}>
      <ThemeContext.Provider
        value={{ bg: props.backgroundColor, font: props.fontColor }}
      >
        <div
          id="containerMain1234"
          ref={container}
          style={{
            position: "fixed",
            right: -componentPos.a + 10,
            bottom: "90px",
          }}
          // {...bindComponentPos()}
          className={`${
            open ? "flex absolute right-[10%]" : "hidden"
          } select-none z-[20000000]`}
        >
          {state}
        </div>
        <button
          className="w-fit fixed bottom-1 right-2 opacity-70 hover:opacity-100 h-[2.2rem] bg-[#2E72EF] z-[20000000] text-xs flex flex-row items-center space-x-2 pl-1 pr-2 rounded-full text-white"
          onClick={(e) => {
            setOpen(!open);
            if (initial) {
              setInitial(false);
            }
            e.stopPropagation();
          }}
        >
          <img alt="" src={logo} className="w-[1.5rem] select-none ml-1" />
          <div className="h-full select-none border-l-2 border-white"></div>
          {open
            ? window.parent.postMessage(
                [
                  "x",
                  "qcast-active",
                  `${container.current.clientWidth + 40}px`,
                  `${container.current.clientHeight + 100}px`,
                ],
                "*"
              )
            : window.parent.postMessage(["x", "qcast-hidden"], "*")}
          {open ? (
            <p className="select-none w-[-webkit-fill-available]">
              Close Qcast
            </p>
          ) : (
            <p className="select-none w-[-webkit-fill-available]">
              Begin conversation
            </p>
          )}
        </button>
      </ThemeContext.Provider>
    </Provider>
  );
};

export default Qcast;
